import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import { useState, useRef, useEffect, SetStateAction } from 'react';
import debounce from '../../utility/login_debounce';
import { JSX } from 'react/jsx-runtime';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useNavigate, NavLink } from "react-router-dom";
import { signInAnonymously, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { collection, query, where, setDoc, getDocs, getDoc, doc } from "firebase/firestore";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useFirebase } from '../auth/context';
import { useRouteContext } from '../auth/route-context';
import logoGoogle from "../../assets/web_neutral_rd_na@4x.png";
import img1 from '../../assets/mmk-favicon-design.png';
import './login-page.css';

const initState = {
    email: '',
    password: ''
}

const LoginPage = () => {
    const [formData, setFormData] = useState(initState);
    const [emailStatus, setemailStatus] = useState(0);
    const [passwordStatus, setPasswordStatus] = useState(0);
    const [submittedOnce, setSubmittedOnce] = useState(false);
    const [tabbedCount, setTabbedCount] = useState(0);
    const [anonymousLoading, setAnonymousLoading] = useState(false);

    const [formError, setFormError] = useState([<></>]);
    const refSubmitButton = useRef(<input />);
    const refFirstTab = useRef(<input />);
    const refPassTab = useRef(<input />);

    const navigate = useNavigate();
    const existingRoute = useRouteContext();

    const [hidePassword, setHidePassword] = useState(true);

    let debouncedForm = useRef(debounce(() => { }, 255)) as any;

    let debouncedButton = useRef(debounce(() => { }, 55)) as any;

    useEffect(() => {
        window.scroll(0, 0);
        (refFirstTab?.current as any).focus();
    }, [])

    const { auth, db } = useFirebase();

    useEffect(() => {
        if (submittedOnce) {
            if (formError[0]?.props?.children?.includes('Email')) {
                const emailBox = document.querySelector('#email');
                emailBox?.animate(
                    [{ transform: "translate3d(0, 0, 0)" }, { transform: "translate3d(7px, 0, 7px)" }],
                    {
                        duration: 255,
                        iterations: 2,
                        direction: "alternate",
                    }
                );
                (refFirstTab.current as any)?.focus();
            } else if (formError[0]?.props?.children?.includes('Password')) {
                const passBox = document.querySelector('#password');
                passBox?.animate(
                    [{ transform: "translate3d(0, 0, 0)" }, { transform: "translate3d(7px, 0, 7px)" }],
                    {
                        duration: 127,
                        iterations: 4,
                        direction: "alternate",
                    }
                );
                (refPassTab.current as any)?.focus();
            }
        }
    }, [formError])

    const onChangeForm = async ({ name, value }: { name: string, value: string }) => {
        setFormData({ ...formData, [name]: value });
        if (name === 'email' && tabbedCount > 0) {
            // if (typeof debouncedForm === 'function') {
            debouncedForm.current = debounce(() => { console.log('email value', value); debouncedemailFunction(value) }, 255, debouncedForm.current());
            if (typeof debouncedForm.current === 'function') {
                debouncedForm.current();
            }
            // }
        } else if (name === 'password' && tabbedCount > 1) {
            const errors = findPasswordErrors(value)
            if (errors?.length) {
                setPasswordStatus(-1);
                setFormError(errors);
            } else {
                setFormError([<></>])
                setPasswordStatus(0);
            }
        }
    }

    const debouncedemailFunction = async (value: any) => {
        let errors = await findemailErrors(value)
        if (errors.length) {
            setemailStatus(-1);
            setFormError(errors);
        } else {
            setFormError([<></>])
            setemailStatus(1);
        }
    }

    const checkIfUserExists = async (email: String) => {
        try {
            const usersRef = collection(db, "users"); // Reference to users collection
            const q = query(usersRef, where("email", "==", email)); // Query for email match
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                // console.log("User exists:", querySnapshot.docs[0].data());
                return true; // User exists
            } else {
                // console.log("User does not exist");
                return false; // User does not exist
            }
        } catch (error) {
            console.error("Error checking user existence:", error);
            return false;
        }
    };

    const findemailErrors = async (value = formData.email) => {
        let errors: SetStateAction<JSX.Element[]> = [];
        let emailCheck = await checkIfUserExists(value);
        if (!value) {
            errors = [<div style={{ color: 'aliceblue' }}>Please Meet Following Email Requirements:</div>];
            errors = [...errors, <div style={{ whiteSpace: 'pre' }}>&#8226; Email is Required</div>]
        } // eslint-disable-next-line 
        else if (!value.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
            errors = [<div style={{ color: 'aliceblue' }}>Please Meet Following Email Requirements:</div>];
            errors = [...errors, <div style={{ whiteSpace: 'pre' }}>&#8226; Incorrect Email Format!</div>]
        } else if (emailCheck !== true) {
            errors = [<div style={{ color: 'aliceblue' }}>Please Meet Following Email Requirements:</div>];
            errors = [...errors, <div style={{ whiteSpace: 'pre' }}>&#8226; Email Does Not Exist! Please Register.</div>]
        } else {
            errors = []
        }
        return errors
    }

    const findPasswordErrors = (value = formData.password) => {
        let errors: SetStateAction<JSX.Element[]> = [];
        errors = !errors[0]?.props?.children?.includes('Password Requirements') ? [...errors, <div style={{ color: 'red' }}>Please Meet Following Password Requirements:</div>] : errors;
        if (!value) {
            errors = [...errors, <div style={{ whiteSpace: 'pre' }}>&#8226; Password is Required!</div>]
            return errors;
        } else {
            return [];
        }
    }

    const onClickAnimation = () => {
        const box = document.querySelector('.errorBoxInner') as any;
        box?.animate(
            { transform: 'translateX(10px)' },
            {
                duration: 100
            }
        );
    }
    const OnSubmit = async () => {
        setSubmittedOnce(true);
        let errorsEmail = await findemailErrors();
        let errorsPass = findPasswordErrors();
        if (errorsEmail.length > 0) {
            setFormError(errorsEmail);
            setemailStatus(-1);
            onClickAnimation();
            return;
        } else if (errorsPass?.length) {
            setFormError(errorsPass);
            setPasswordStatus(-1);
            onClickAnimation();
            return;
        } else {
            setFormError([<></>]);
        }
        debouncedButton.current = debounce(() => { debouncedSubmitFunction() }, 55, debouncedButton.current());
        if (typeof debouncedButton.current === 'function') {
            debouncedButton.current();
        }
    }

    const loginFunction = async () => {
        try {
            // &#x0031;&#xFE0F;&#x20E3; Sign in user
            const userCredential = await signInWithEmailAndPassword(auth, formData.email, formData.password);
            const user = userCredential.user;

            // &#x0032;&#xFE0F;&#x20E3; Check if email is verified
            if (!user.emailVerified) {
                await signOut(auth); // Sign out if email not verified
                setFormError([<>Please verify your email before logging in!</>]);
                return;
            }

            // &#x0033;&#xFE0F;&#x20E3; Fetch user profile from Firestore
            const userDoc = await getDoc(doc(db, "users", user.uid));
            if (!userDoc.exists()) {
                setFormError([<>User data not found. Please contact support.</>]);
                return;
            }

            // &#x0034;&#xFE0F;&#x20E3; Navigate to dashboard
            navigate('/welcome', { state: { userName: userDoc.data().username }, replace: true });

        } catch (error) {
            setFormError([<>Invalid Credentials.</>]);
            console.log("Login Error:", error);
        }
    };


    const googleProvider = new GoogleAuthProvider();

    const signInWithGoogle = async () => {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;

            console.log("User signed in with Google:", user);

            // Check if user already exists in Firestore
            const userRef = doc(db, "users", user.uid);
            const userSnap = await getDoc(userRef);

            if (!userSnap.exists()) {
                // &#x0031;&#xFE0F;&#x20E3; New user, store additional info in Firestore
                await setDoc(userRef, {
                    username: user.displayName || "Anonymous",
                    email: user.email,
                    photoURL: user.photoURL || "",
                    createdAt: new Date().toISOString(),
                    emailVerified: user.emailVerified,
                });
            }

            // &#x0032;&#xFE0F;&#x20E3; Redirect to dashboard or home
            navigate("/welcome");

        } catch (error: any) {
            console.error("Google Sign-In Error:", error);
            let errorMessage = "An unexpected error occurred.";

            if (error.code === "auth/popup-closed-by-user") {
                errorMessage = "Google Sign-In popup closed. Please try again.";
            } else if (error.code === "auth/cancelled-popup-request") {
                errorMessage = "Google Sign-In was canceled.";
            }

            setFormError([<>{errorMessage}</>]);
        }
    };

    const getAnonymousTargetPath = () => (
        existingRoute?.path?.includes("/blog/") ? existingRoute.path : "/blog/home"
    );

    const continueAsGuestWithoutFirebase = (targetPath: string) => {
        window.sessionStorage.setItem("blogAnonymousGuest", "true");
        window.sessionStorage.setItem("blogAnonymousGuestTarget", targetPath);
        navigate(targetPath, {
            replace: true,
            state: {
                from: "anonymous",
                anonymousGuest: true,
            },
        });
    };

    const continueAsAnonymous = async () => {
        setAnonymousLoading(true);
        const targetPath = getAnonymousTargetPath();

        try {
            const result = await signInAnonymously(auth);
            const user = result.user;

            await setDoc(doc(db, "users", user.uid), {
                uid: user.uid,
                username: "Anonymous",
                email: null,
                isAnonymous: true,
                lastLogin: new Date().toISOString(),
            }, { merge: true });

            navigate(targetPath, {
                replace: true,
                state: {
                    from: "anonymous",
                    anonymousGuest: true,
                },
            });
        } catch (error: any) {
            console.error("Anonymous Sign-In Error:", error);
            continueAsGuestWithoutFirebase(targetPath);
        } finally {
            setAnonymousLoading(false);
        }
    };



    const debouncedSubmitFunction = async () => {
        // try {
        loginFunction();
        // } catch (e) {
        //     const errors = [<div style={{ color: 'red' }}>Following Error Occurred:</div>];
        //     setFormError([...errors, <div style={{ color: 'red' }}>{(e as any)?.response?.data?.error ? (e as any)?.response?.data?.error : "Network Error. Please Try Again!"}</div>]);
        //     console.log(e)
        // }
        (refSubmitButton?.current as any)?.blur();
    }

    const OnTabbedOnce = async () => {
        const errorsEmail = await findemailErrors();
        let errorsPass = findPasswordErrors();
        let errorBool = false;
        // console.log(tabbedCount, errorsEmail);
        if (tabbedCount > 0 && errorsEmail?.length > 0) {
            setFormError(errorsEmail);
            setemailStatus(-1);
            errorBool = true;
        } else if (tabbedCount > 1 && errorsPass?.length > 0) {
            setFormError(errorsPass);
            setPasswordStatus(-1);
            errorBool = true;
        }
        if (errorBool && tabbedCount > 2 && errorsPass?.length) {
            setPasswordStatus(-1);
        }
        if (!errorBool) {
            setFormError([<></>]);
        }
        setTabbedCount(tabbedCount + 1);
    }

    return (
        <main
            className="login-page"
            onKeyDown={(e) => { e.key === 'Tab' && tabbedCount < 4 && OnTabbedOnce() }}
        >
            <section className="login-shell" aria-label="Sign in to Matheen Mohammed Khan's Blog">
                <aside className="login-brand-panel">
                    <div className="login-brand-lockup">
                        <img className="login-brand-mark" src={img1} alt="" />
                    </div>
                    <div className="login-brand-copy">
                        <span className="login-brand-title">Matheen Mohammed Khan's Blog</span>
                        <span className="login-eyebrow">Ideas for a thoughtful life</span>
                        <h2>Read. Reflect. Grow.</h2>
                        <p>Find perspective, practical ideas, and writing on the things that shape how we live.</p>
                    </div>
                    <div className="login-brand-note">
                        <span className="login-note-dot" aria-hidden="true" />
                        <span>A space for learning, meaning, and new perspectives.</span>
                    </div>
                    <div className="login-brand-orb login-brand-orb-one" aria-hidden="true" />
                    <div className="login-brand-orb login-brand-orb-two" aria-hidden="true" />
                </aside>

                <div className="login-form-panel">
                    <div className="login-form-heading">
                        <span className="login-eyebrow login-eyebrow-dark">Welcome back</span>
                        <h1>Sign in</h1>
                        <p>Use your account to continue to Matheen Mohammed Khan's Blog.</p>
                    </div>

                    <form
                        className="login-form"
                        noValidate
                        onSubmit={(event) => { event.preventDefault(); void OnSubmit(); }}
                    >
                        <div className="login-field">
                            <div className="login-field-heading">
                                <label htmlFor="email">Email address</label>
                                <span className="login-field-status" aria-live="polite">
                                    {emailStatus === 1 ? <CheckCircleRoundedIcon aria-label="Email looks good" /> : emailStatus === -1 ? <ErrorRoundedIcon className="login-status-error" aria-label="Email needs attention" /> : null}
                                </span>
                            </div>
                            <input
                                type="email"
                                maxLength={45}
                                onBlur={() => OnTabbedOnce()}
                                ref={refFirstTab as any}
                                tabIndex={1}
                                id="email"
                                className="login-input"
                                placeholder="you@example.com"
                                name="email"
                                autoComplete="email"
                                aria-invalid={emailStatus === -1}
                                value={formData.email}
                                onChange={(e: any) => onChangeForm(e.target)}
                            />
                        </div>

                        <div className="login-field">
                            <div className="login-field-heading">
                                <label htmlFor="password">Password</label>
                                <span className="login-field-status" aria-live="polite">
                                    {passwordStatus === 1 ? <CheckCircleRoundedIcon aria-label="Password looks good" /> : passwordStatus === -1 ? <ErrorRoundedIcon className="login-status-error" aria-label="Password needs attention" /> : null}
                                </span>
                            </div>
                            <div className="login-password-wrap">
                                <input
                                    type={hidePassword ? 'password' : 'text'}
                                    maxLength={45}
                                    ref={refPassTab as any}
                                    tabIndex={2}
                                    className="login-input login-password-input"
                                    id="password"
                                    placeholder="Enter your password"
                                    name="password"
                                    autoComplete="current-password"
                                    aria-invalid={passwordStatus === -1}
                                    value={formData.password}
                                    onChange={(e: any) => onChangeForm(e.target)}
                                />
                                <button
                                    className="login-password-toggle"
                                    type="button"
                                    aria-label={hidePassword ? 'Show password' : 'Hide password'}
                                    aria-pressed={!hidePassword}
                                    onClick={() => setHidePassword(!hidePassword)}
                                >
                                    {hidePassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                </button>
                            </div>
                        </div>

                        <div className="login-form-links">
                            <NavLink to="/login/forgot-password">Forgot password?</NavLink>
                        </div>

                        {passwordStatus === -1 || emailStatus === -1 || formError.length > 0 ? (
                            <div className="errorBoxInner login-error" role="alert" aria-live="assertive">{formError}</div>
                        ) : null}

                        <div className="login-primary-actions">
                            <button type="submit" tabIndex={3} ref={refSubmitButton as any} className="login-submit-button">
                                Sign in
                            </button>
                            <button
                                type="button"
                                tabIndex={4}
                                className="login-register-button"
                                onClick={() => navigate('/register', { state: { email: formData.email || '' } })}
                            >
                                Create account
                            </button>
                        </div>
                    </form>

                    <div className="login-divider"><span>or continue with</span></div>

                    <div className="login-alternative-actions">
                        <button className="login-provider-button login-google-button" type="button" onClick={signInWithGoogle}>
                            <img src={logoGoogle} alt="" />
                            <span>Sign in with Google</span>
                        </button>
                        <button className="login-provider-button" type="button" onClick={continueAsAnonymous} disabled={anonymousLoading}>
                            {anonymousLoading ? 'Signing in…' : 'Continue as Anonymous'}
                        </button>
                        <button className="login-provider-button login-ai-button" type="button" onClick={() => navigate('/ai-suggestor')}>
                            <span aria-hidden="true">✦</span> Continue as a Guest (AI Suggestor)
                        </button>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default LoginPage;
